exports.services = [
    {
        'id': 1,
        'img': 'webd.png',
        'heading': 'Performance Optimization',
        'desc': 'Improving website loading speed and overall performance. Minimizing code and asset size, implementing caching, and optimizing server configurations.',
        delay: '200'
    },
    {
        'id': 2,
        'img': 'appd.png',
        'heading': 'Responsive Designs',
        'desc': 'Our proficiency lies in creating captivating user experiences across various devices, guaranteeing optimal levels of engagement and conversion rates.',
        delay: '300'
    },
    {
        'id': 3,
        'img': 'blockchain.png',
        'heading': 'Flexibility & Scalability',
        'desc': 'Our flexible solutions effectively cater to the growth and expansion of your business, enabling you to maintain a competitive edge.',
        delay: '400'
    },
    {
        'id': 4,
        'img': 'itconsultancy.png',
        'heading': 'Client Centric Approach',
        'desc': "Your objectives and preferences are given utmost importance as we customize web design experiences that surpass your expectations.",
        delay: '500'
    },
    {
        'id': 6,
        'img': 'seo.png',
        'heading': 'Web Hosting and Deployment',
        'desc': 'Helping clients choose suitable hosting solutions. Deploying websites to hosting servers and configuring domain settings.',
        delay: '600'
    },
    {
        'id': 5,
        'img': 'dataanalyst.png',
        'heading': 'Data Analysis',
        'desc': 'Transform data into actionable insights. Our data analysis services decode the information maze, guiding your decisions with precision.',
        delay: '700'
    },
    {
        'id': 7,
        'img': 'graphicdesign.png',
        'heading': 'Content Management',
        'desc': 'The task at hand involves the establishment and customization of content management systems for clients, enabling them to conveniently modify and update the content of their websites.',
        delay: '800'
    },
    {
        'id': 8,
        'img': 'itconsultancy.png',
        'heading': 'Support',
        'desc': "Offering technical assistance and resolving any problems that may occur subsequent to the launch.",
        delay: '900'
    }
]

exports.projects = [
    {

    }
]
